var WeekStarters;
(function (WeekStarters) {
    WeekStarters["Sunday"] = "sunday";
    WeekStarters["Monday"] = "monday";
    WeekStarters["Saturday"] = "saturday";
})(WeekStarters || (WeekStarters = {}));
export default WeekStarters;
//# sourceMappingURL=WeekStartersEnum.js.map